import { Classes, Colors, Drawer, MaybeElement } from '@blueprintjs/core';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState } from '../../../stores';
import { setSidebar } from '../../../stores/ui';
import { saveSidebar } from '../../../utils/storage';
import Header, { HeaderContext } from '../Header';
import Sidebar from '../Sidebar';
import styles from './mainbase.module.css';

interface Props {
  children?: React.ReactNode,
}

const MainBase: React.FC<Props> = ({ children }) => {
  const [content, setContent] = useState<MaybeElement>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  const dispatch = useDispatch();
  const { dark, sidebar } = useSelector((s: RootState) => s.ui);

  const isCollapsed = sidebar === 'collapse';
  const className = [isCollapsed ? styles.collapse : styles.expand].filter(Boolean).join(' ');

  const onCollapse = () =>{
    const state = sidebar === 'collapse' ? 'expand' : 'collapse';
    saveSidebar(state);
    dispatch(setSidebar(state));
  }

  // Tutup drawer mobile setelah pindah halaman.
  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <HeaderContext.Provider value={{ content, setContent }}>
      <Header collapse={isCollapsed} className={styles.header} onMenuClick={() => setMenuOpen(true)} />

      <Drawer
        className={[styles.drawer, dark ? Classes.DARK : ''].filter(Boolean).join(' ')}
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        position="left"
        size="min(280px, 85vw)"
      >
        <Sidebar mobile onCollapse={onCollapse} />
      </Drawer>

      <div className={className}>
        <div className={styles.sidebar}>
          <Sidebar collapsed={isCollapsed} onCollapse={onCollapse} />
        </div>

        <div
          className={styles.content}
          style={{ backgroundColor: dark ? Colors.DARK_GRAY1 : Colors.LIGHT_GRAY5 }}
        >
          {children}
        </div>
      </div>
    </HeaderContext.Provider>
  );
};

export default MainBase;
